import { useModal } from "../../../utils/ModalContext";
import { ethers } from "ethers";
import { FiX, FiChevronRight } from "react-icons/fi";
import NetworkModalStyleWrapper from "./NetworkModal.style.js";
import metamaskIcon from "../../../assets/images/icon/MetaMask.svg";
import polygonIcon from "../../../assets/images/icon/polygon-matic-logo.png";
import { getChainId } from "../../../lib/metamaskhandler";
import { useState } from "react";
import { useEffect } from "react";
import {
  NETWORK,
  NETWORK_NAME,
  NETWORK_URL,
  NETWORK_SYMB,
  NETWORK_EXPLORER,
  TOKEN_NAME
} from "../../../utils/constants";

const NetworkModal = () => {
  const { handleNetworkModal, setNetworkModalVisibility, setNetwork } =
    useModal();

  const [nameNetwork, setNameNetwork] = useState("");

  useEffect(() => {
    if (window.ethereum) {
      const getChainName = async () => {
        const provider = new ethers.providers.Web3Provider(
          window.ethereum,
          "any"
        );

        const network = await provider.getNetwork();

        const capitalizedName =
          network.name.charAt(0).toUpperCase() + network.name.slice(1);

        setNameNetwork(capitalizedName);
      };

      getChainName();
    }
  }, [nameNetwork]);

  console.log(nameNetwork);

  const handleChangeNetwork = async (e) => {
    e.preventDefault();

    const getChain = await window.ethereum.request({
      method: "wallet_switchEthereumChain",
      params: [{ chainId: `0x${Number(NETWORK).toString(16)}` }], // chainId must be in hexadecimal numbers
    });

    setNetwork(await getChainId());

    setNetworkModalVisibility(false);
  };

  const handleAddNetwork = async (e) => {
    e.preventDefault();

    console.log("entraaa")

    const addChain = await window.ethereum.request({
      method: "wallet_addEthereumChain",
      params: [
        {
          chainId: `0x${Number(NETWORK).toString(16)}`,
          blockExplorerUrls: [NETWORK_EXPLORER],
          chainName: NETWORK_NAME,
          rpcUrls: [NETWORK_URL],
          nativeCurrency: {
            name: TOKEN_NAME,
            symbol: NETWORK_SYMB,
            decimals: 18 //In number form
         },
         
        },
      ], // chainId must be in hexadecimal numbers
    });
  };

  return (
    <>
      <NetworkModalStyleWrapper className="modal_overlay">
        <div className="mint_modal_box">
          <div className="mint_modal_content">
            <div className="modal_header">
              <h2>Wrong Network</h2>
              <button onClick={() => handleNetworkModal()}>
                <FiX />
              </button>
            </div>
            <div className="modal_body text-center">
              <div className="modal_bottom_text">
                You need to be connected to <strong>Polygon Mainnet</strong> in
                order to use this app. You're currently connected to{" "}
                <strong>{nameNetwork}.</strong>
              </div>

              <div className="wallet_list">
                <h5 href="# " onClick={(e) => handleAddNetwork(e)}>
                  <img src={polygonIcon} alt="polygon-Image" />
                  ADD POLYGON NETWORK
                  <span>
                    <FiChevronRight />
                  </span>
                </h5>
                <h5 href="# " onClick={(e) => handleChangeNetwork(e)}>
                  <img src={polygonIcon} alt="polygon-Image" />
                  SWITCH TO POLYGON MAINNET
                  <span>
                    <FiChevronRight />
                  </span>
                </h5>
              </div>
            </div>
          </div>
        </div>
      </NetworkModalStyleWrapper>
    </>
  );
};

export default NetworkModal;
